import { 
    LOGIN_SUCCESS,
    LOGOUT, 
    LOGIN_FAIL,
    USER_LOADED,
    AUTH_ERROR
} from '../actions/types';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: null,
    loading: true,
    user: null
};

if(initialState.token){
    initialState.isAuthenticated = true;
    initialState.loading = false;
}

export default function( state = initialState, action){
    const { type, payload } = action
    switch (type) {
        case LOGIN_SUCCESS:
            localStorage.setItem('token', payload.token);
            return {
                ...state, 
                ...payload,
                isAuthenticated: true,
                loading: false
            };
        case USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload
            };
        case AUTH_ERROR:
        case LOGIN_FAIL:
        case LOGOUT:
            localStorage.removeItem('token');
            return {
                token: null,
                isAuthenticated: false,
                loading: false
            };
        default:
            return state;
    }
}
